import { useState, useEffect } from "react"

/**
 * Hook that tracks if a component has mounted
 * Useful for preventing SSR hydration issues or delaying certain effects
 * @returns {boolean} isMounted - Whether the component has mounted
 */
export const useIsMounted = () => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return isMounted
}

export default useIsMounted
